import * as React from 'react';
import "./LeadRefNumberFilter.scss";
import InputWithIcon from "../../../../hiberUiKit/src/atoms/Input/InputWithIcon";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import {none, Option, option} from "ts-option";
import * as _ from "underscore";
import WildcardFilter from "../../../../model/workspace/WildcardFilter";
import LocalStorage from "../../../../store/local/LocalStorage";

interface IProps {
	/**
	 * On filter change callback.
	 * @param {string} value
	 */
	onFilterChange: (value: Option<WildcardFilter>) => void;
	/**
	 * Stored filter in parent component
	 */
	filterValue: Option<WildcardFilter>
	/**
	 * Indicates if list is loading.
	 */
	isLoading: boolean
	/**
	 * Workspace name
	 */
	workspaceName: string
}

interface IState {
	value: string
}

export default class WildcardSearch extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {value: ""}
	}

	componentDidMount() {
		const workspaceSearch = LocalStorage.getWorkspaceSearch(this.props.workspaceName);
		if (workspaceSearch) {
			this.setState({value: workspaceSearch})
		}
	}

	componentWillReceiveProps(nextProps: Readonly<IProps>): void {
		if (this.props.filterValue.isDefined && nextProps.filterValue.isEmpty) {
			this.setState({value: ""});
		}
	}

	render() {
		return (
			<div className={"c-workspace-quick-filter"}>
				<InputWithIcon type={"text"}
							   value={this.state.value}
							   placeholder={"Search"}
							   clearable={true}
							   onClearClick={this.onReset}
							   prependIcon={Icon.Search}
							   disabled={false}
							   onChange={this.onChange}/>
			</div>
		);
	}

	/**
	 * On input change.
	 */
	onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({value: evt.target.value});
		if (evt.target.value === "") {
			this.onChangeDebounced(none);
		}
		else {
			this.onChangeDebounced(option(new WildcardFilter(evt.target.value)));
		}
	};

	onChangeDebounced = _.debounce(this.props.onFilterChange, 300);

	/**
	 * On reset button.
	 */
	onReset = () => {
		if (!this.props.isLoading) {
			this.setState({value: ""});
			this.props.onFilterChange(none);
		}
	}
}
